import "core-js/modules/es.array.is-array";
import React from 'react';
import PropTypes from 'prop-types';
import FootnoteContent from './FootnoteContent';
import Translatable from '../../../translatable/Translatable';
import CardTitle from '../show-hide/CardTitle';
import CmsAccordion from '../../utils/cms-accordion/CmsAccordion';

var Footnotes = function Footnotes(_ref) {
  var content = _ref.content,
      templateType = _ref.templateType;
  return content && Array.isArray(content) && content.length ? /*#__PURE__*/React.createElement(CmsAccordion, {
    templateType: templateType,
    defaultOpen: templateType === 'MARKETING' || templateType === 'NOTIFICATION' || templateType === 'SERVICE',
    title: /*#__PURE__*/React.createElement(CardTitle, {
      el: "h3",
      title: templateType === 'MARKETING' || templateType === 'NOTIFICATION' ? 'Important Information and Footnotes' : /*#__PURE__*/React.createElement(Translatable, {
        id: "cms.footnotes"
      })
    }),
    content: /*#__PURE__*/React.createElement(FootnoteContent, {
      templateType: templateType,
      content: content
    })
  }) : null;
};

Footnotes.propTypes = {
  content: PropTypes.array.isRequired
};
export default Footnotes;